import * as service from './service'
export default {
  namespace: 'TrainingSite',
  state: {
    demoData: {}
  },
  effects: {
    * trainAddrDetailInfo ({ payload }, { call, put }) {
      const res = yield call(service.trainAddrDetailInfo, payload)
      return res.data.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
